import { createSensor as createObjectSensor } from './object';
import { createSensor as createResizeObserverSensor } from './observer';
export const createSensor = typeof ResizeObserver !== 'undefined'
    ? createResizeObserverSensor
    : createObjectSensor;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/x6-common/es/size-sensor/sensors/index.js
// module id = null
// module chunks = 